import React, { useEffect, useState } from 'react';
import { Alert, AlertColor, Snackbar, SnackbarCloseReason } from '@mui/material';

interface ErrorMessageProps {
  message: string; // Message to display
  severity?: AlertColor;
  autoHideDuration?: number | null;
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  onClose?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  severity = 'error',
  autoHideDuration,
  anchorOrigin = { vertical: 'top', horizontal: 'center' },
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(Boolean(message));
  }, [message]);

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') return;
    setIsVisible(false);
    onClose?.();
  };

  if (!message) return null;

  return (
    <Snackbar
      open={isVisible}
      autoHideDuration={autoHideDuration ?? null}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert severity={severity} onClose={() => handleClose()} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ErrorMessage;
